module.exports = "https://cdn-challenge.mathletics.com/app/297/assets/images/d94ff847a95dd381ae85a39a5b95f777.svg";